import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { provide } from '@lit/context';

import './pages/app-home';
import './components/header';
import './components/app-nav';
import './components/app-footer';
import './components/brainstorm-sidebar';
import './styles/global.css';
import { router } from './router';
import { ElementInspector } from './utils/element-inspector';
import { AuthController } from './controllers/auth-controller';
import { authContext } from './contexts/auth-context';

@customElement('app-index')
export class AppIndex extends LitElement {
  // Auth controller
  private authController = new AuthController(this);

  // Provide auth context to all child components
  @provide({ context: authContext })
  get authState() {
    return this.authController.authState;
  }
  static styles = css`
    :host {
      display: block;
    }

    .page-content {
      margin-top: 60px; /* Space for fixed header (desktop) */
      margin-bottom: 36px; /* Space for fixed footer (desktop) */
      height: calc(100vh - 96px); /* Full height minus header (60px) and footer (36px) */
    }

    /* Mobile: Header at bottom, footer at bottom too but hidden */
    @media (max-width: 768px) {
      .page-content {
        margin-top: 0; /* No header at top on mobile */
        margin-bottom: 60px; /* Space for fixed nav at bottom */
      }
    }
  `;

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ("startViewTransition" in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      }
      else {
        this.requestUpdate();
      }
    });

    // Initialize element inspector (Alt+X+C to activate)
    new ElementInspector();
  }

  render() {
    // Get current route to determine active nav
    const path = window.location.pathname;
    let activeNav = 'home';
    if (path.includes('/brainstorm')) activeNav = 'brainstorm';
    else if (path.includes('/calendar')) activeNav = 'calendar';
    else if (path.includes('/about')) activeNav = 'about';
    else if (path.includes('/login')) activeNav = 'profile';

    // Determine if sidebar should be visible
    const showSidebar = path.includes('/brainstorm') || path.includes('/calendar');

    return html`
      <!-- Global Sidebar (shows on specific pages) -->
      <brainstorm-sidebar
        ?visible=${showSidebar}
      ></brainstorm-sidebar>

      <app-nav activeNav="${activeNav}"></app-nav>
      <div class="page-content">
        ${router.render()}
      </div>
      <app-footer></app-footer>
    `;
  }
}
